import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import sarah from '../../assets/avatars/sarah-jenkins.png';
import david from '../../assets/avatars/david-chen.png';
import elena from '../../assets/avatars/elena-rodriguez.png';

export type OrgStatus = 'active' | 'inactive';
export type OrgIconKind = 'building' | 'shield' | 'transport';

export interface Organization {
  id: string;
  name: string;
  icon: OrgIconKind;
  status: OrgStatus;
  contactName: string;
  contactAvatar: string;
}

export interface OrganizationsResponse {
  items: Organization[];
  total: number;
  page: number;
  pageSize: number;
}

/** Mock dataset mirroring the Figma "Organizations" table. */
const MOCK_ORGS: Organization[] = [
  {
    id: '1',
    name: 'Municipal Governance Department',
    icon: 'building',
    status: 'active',
    contactName: 'Sarah Jenkins',
    contactAvatar: sarah,
  },
  {
    id: '2',
    name: 'Public Health Authority',
    icon: 'shield',
    status: 'inactive',
    contactName: 'David Chen',
    contactAvatar: david,
  },
  {
    id: '3',
    name: 'Transport Infrastructure Board',
    icon: 'transport',
    status: 'active',
    contactName: 'Elena Rodriguez',
    contactAvatar: elena,
  },
];

/**
 * RTK Query API. Uses `fakeBaseQuery` today so the UI runs without a backend;
 * swap `queryFn` for a real `baseQuery` (e.g. fetchBaseQuery) when the API exists.
 */
export const organizationsApi = createApi({
  reducerPath: 'organizationsApi',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['Organizations'],
  endpoints: (builder) => ({
    getOrganizations: builder.query<OrganizationsResponse, { page?: number } | void>({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      async queryFn(arg) {
        const page = (arg && arg.page) || 1;
        // Simulate network latency
        await new Promise((r) => setTimeout(r, 400));
        return {
          data: {
            items: MOCK_ORGS,
            total: 124,
            page,
            pageSize: 3,
          },
        };
      },
      providesTags: ['Organizations'],
    }),
  }),
});

export const { useGetOrganizationsQuery } = organizationsApi;
